export default "__VITE_PUBLIC_ASSET__9084d39a__"